import React from 'react';
import { useSelector } from 'react-redux';
import { getLoggedUserSelector } from '@hero/redux-data/backoffice/userStatus/selectors';
import * as styles from '../../components/DefaultLayout/style.module.css';
import InlineLoader from '../../components/InlineLoader';
import NotificationArea from '../../components/NotificationArea';
import Navigation from '../../components/Navigation';

// Same chrome as DefaultLayout, but the loader only covers the first status load:
// DefaultLayout also swaps children out on every token-refresh refetch, which would
// unmount Mark editors and drop unsaved drafts.
const MarkLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const user = useSelector(getLoggedUserSelector);
    const userId = user?.status?.user_id || 0;
    return (
        <div className={styles.container}>
            <div className={styles.contentWrap}>
                <Navigation />

                <div className={`${styles.mainContent} ${styles.mainContentModern}`}>
                    {userId === 0 ? (
                        <InlineLoader />
                    ) : (
                        <>
                            <div className={styles.notificationsWrap}>
                                <NotificationArea />
                            </div>
                            <div className={styles.contentInnerWrap}>{children}</div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MarkLayout;
